// @flow strict

import * as React from 'react';
import cx from 'classnames';
import styles from './styles.scss';
import PageContentBlock from '../../internal/PageContentBlock';
import { Link } from '../../internal/Button';

type PropTypes = {|
  title?: string,
  links: Array<{|
    href: string,
    title: string,
  |}>,
|};

export default (props: PropTypes) => {
  return (
    <PageContentBlock layout="Thin">
      <div>
        {props.title && <h2 className={styles.title}>{props.title}</h2>}
        <ul className={cx(!props.title && styles.noTitle)}>
          {props.links.map((article, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <li key={index}>
              <Link href={article.href} className={styles.article} variant="SubtleLink">
                {article.title}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </PageContentBlock>
  );
};
